export enum AuthSidebarMode {
  login = 'login',
  preRegister = 'pre-register',
  register = 'register',
  resetPassword = 'reset-password',
  newPassword = 'new-password'
}
